(function () {
  function getTimePartsInZone(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    var parts = formatter.formatToParts(date);
    var map = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        map[part.type] = part.value;
      }
    });

    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      hour: Number(map.hour),
      minute: Number(map.minute),
      second: Number(map.second)
    };
  }

  function formatUnit(value) {
    return String(value).padStart(2, '0');
  }

  function updateShippingTimer(timer) {
    var cutoffHour = Number(timer.dataset.cutoffHour || 15);
    var cutoffMinute = Number(timer.dataset.cutoffMinute || 0);
    var timeZone = timer.dataset.timezone || 'America/Los_Angeles';

    var now = new Date();
    var zonedNow = getTimePartsInZone(now, timeZone);

    var currentSeconds = (zonedNow.hour * 60 * 60) + (zonedNow.minute * 60) + zonedNow.second;
    var cutoffSeconds = (cutoffHour * 60 * 60) + (cutoffMinute * 60);

    var isAfterCutoff = currentSeconds >= cutoffSeconds;

    var beforeEl = timer.querySelector('[data-before-cutoff-message]');
    var afterEl = timer.querySelector('[data-after-cutoff-message]');

    if (beforeEl && afterEl) {
      beforeEl.classList.toggle('is-hidden', isAfterCutoff);
      afterEl.classList.toggle('is-hidden', !isAfterCutoff);
    }

    if (!isAfterCutoff) {
      var remainingSeconds = cutoffSeconds - currentSeconds;
      var hours = Math.floor(remainingSeconds / 3600);
      var minutes = Math.floor((remainingSeconds % 3600) / 60);
      var seconds = remainingSeconds % 60;

      var hoursEl = timer.querySelector('[data-hours]');
      var minutesEl = timer.querySelector('[data-minutes]');
      var secondsEl = timer.querySelector('[data-seconds]');

      if (hoursEl) hoursEl.textContent = formatUnit(hours);
      if (minutesEl) minutesEl.textContent = formatUnit(minutes);
      if (secondsEl) secondsEl.textContent = formatUnit(seconds);
    }
  }

  function initShippingTimers() {
    var timers = document.querySelectorAll('.fuel-shipping-timer');

    if (!timers.length) return;

    timers.forEach(function (timer) {
      updateShippingTimer(timer);

      setInterval(function () {
        updateShippingTimer(timer);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingTimers);
  } else {
    initShippingTimers();
  }
})();
